<a [routerLink]="product?.path?product?.ngPath:[]" (click)="productClick.emit()">

</a>

<div class="image-infos-group d-flex flex-column flex-fill">

  <div class="image-group square-ratio overflow-hidden pointer-event-none">

    <img
      class="content"
      [lazyLoad]="(product?.image|getProfile:'style_b256')?.href"
      [alt]="product?.title">

  </div>

  <div class="infos-group d-flex flex-column px-0 flex-fill justify-content-between">

    <div class="d-flex flex-column align-items-start">

      <span
        [innerHTML]="product?.title"
        class="font-weight-bold mat-body mt-2 item-title">
      </span>

      <span class="mat-caption item-subtitle">{{product?.subTitle}}</span>

    </div>

    <ng-template [ngTemplateOutlet]="variantsTemplate">
    </ng-template>

    <ng-container *ngIf="!(isXs$|async) && (showDescriptionPreview$|async)">

      <ng-container *ngIf="product?.itemDescription as description">
        <p [innerHTML]="description" class="description m-0 mt-2 pointer-event-none">
        </p>
      </ng-container>

    </ng-container>

  </div>

</div>

<ng-template #variantsTemplate>


  <app-product-list-variant
    class="d-flex"
    [resourceIdentifier]="product?.firstVariant"
    [snipcartImageUrl]="(product?.firstVariant?.image|getProfile:'medium')?.href"
    [showSeparator]="true"
    [available]="product?.firstVariant?.available"
    [price]="product?.firstVariant?.price.formatted"
    [listPrice]="product?.firstVariant?.listPrice?.formatted"
    [title]="product?.firstVariant?.unit"
    [taxable]="product?.firstVariant?.taxable"
    [taxIncluded]="product?.firstVariant?.taxIncluded"
    [description]="product?.firstVariant?.plainTextDescription"
    [hasMoreVariants]="product?.variants?.length > 1">
  </app-product-list-variant>


</ng-template>
